/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import { Toolbar, Divider } from '@mui/material';

const toolbarStyles = {
	height: 'var(--app-bar-first-toolbar-height)',
	justifyContent: 'space-between',
	gap: '25px',
	display: 'flex'
};

const secondToolbarStyles = {
	height: 'var(--app-bar-second-toolbar-height)',
	justifyContent: 'center'
};

const dividerStyles = {
	borderColor: 'secondary.100'
};

type ResponsiveToolbarProps = {
	Logo: ReactNode;
	Stepper: ReactNode;
	InfoButtons: ReactNode;
	shouldDisplayTwoRows: boolean;
};

export function ResponsiveToolbar( { shouldDisplayTwoRows, Logo, InfoButtons, Stepper }: ResponsiveToolbarProps ): ReactNode {
	if ( shouldDisplayTwoRows ) {
		return (
			<div>
				<Toolbar variant={ 'dense' } sx={ toolbarStyles } data-testid={ 'upper-toolbar' }>
					{ Logo }
					{ InfoButtons }
				</Toolbar>
				<Divider sx={ dividerStyles }/>
				<Toolbar variant={ 'dense' } sx={ { ...toolbarStyles, ...secondToolbarStyles } } data-testid={ 'lower-toolbar' }>
					{ Stepper }
				</Toolbar>
			</div>
		);
	}

	return (
		<Toolbar variant={ 'dense' } sx={ toolbarStyles } data-testid={ 'single-toolbar' }>
			{ Logo }
			{ Stepper }
			{ InfoButtons }
		</Toolbar>
	);
}
